import React from 'react';
import styled from "styled-components";

/**********************************************************************
 * ▷ Styled Component Section
 **********************************************************************/
const Container = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2000;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  animation: fadeInBg .3s ease-in;

  .loading-text {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2100;
    font-size: 14px;
    font-weight: bold;
    color: white;
  }

  .spinner-box {
    width: 300px;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
  }

  .circle-border {
    width: 150px;
    height: 150px;
    padding: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: rgb(63, 249, 220);
    background: linear-gradient(0deg, rgba(246, 229, 26, 0.1) 30%, rgb(246, 202, 26) 100%);
    animation: spin 1s linear 0s infinite;
  }

  .circle-core {
    width: 100%;
    height: 100%;
    background-color: #666666;
    border-radius: 50%;
  }


  @keyframes fadeInBg {
    from {
      opacity: 0;
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(359deg);
    }
  }
`


const LoadingPop = () => {
    return (
        <Container>
            <div className="loading-text">Loading...</div>
            <div className="spinner-box">
                <div className="circle-border">
                    <div className="circle-core"></div>
                </div>
            </div>
        </Container>
    );
};

export default LoadingPop;
